module.exports = __webpack_public_path__ + "static/media/swap.4c935c3e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/swap.svg
 ** module id = 612
 ** module chunks = 0
 **/